import moment from 'moment';
import axios from 'axios';

import {
  GET_CURRENT_WEATHER,
  GET_COMING_WEATHER,
  SEARCH_ERROR,
  API_KEY_ERROR,
  NETWORK_ERROR,
  SERVER_ERROR,
  GET_WEATHER
} from './types';


export const getCurrentWeather = (
  query,
  apiKey,
  temperatureUnit
) => async dispatch => {
  const res = await getWeatherData(query,'https://api.openweathermap.org/data/2.5/weather?',apiKey=process.env.REACT_APP_OPEN_WEATHER_MAP_KEY,temperatureUnit);

  if (res.type === 'success') {
    dispatch({
      type: GET_CURRENT_WEATHER,
      payload: res.data
    });
  } else {
    dispatch({
      type: res,
      payload: true
    });
  }
};

export const getComingWeather = (
  query,
  apiKey,
  temperatureUnit
) => async dispatch => {
  const res = await getWeatherData(query,'https://api.openweathermap.org/data/2.5/forecast?',apiKey=process.env.REACT_APP_OPEN_WEATHER_MAP_KEY,temperatureUnit);

  // Filter out weather information at 12PM UTC for coming days.
  if (res.type === 'success') {
    dispatch({
      type: GET_COMING_WEATHER,
      payload: res.data.list
        .filter(
          x =>
            moment
              .unix(x.dt)
              .utc()
              .format('HH') === '12'
        )
        .slice(1)
    });
  } else {
    dispatch({
      type: res,
      payload: true
    });
  }
};

const getWeatherData = async (query, url, apiKey, temperatureUnit) => {
	let current_user = JSON.parse(localStorage.getItem('current_user'));
	let token = current_user['authToken'];
	let parameters;
	let unit = temperatureUnit === 'celsius' ? 'metric' : 'imperial';
	const headersToken = {
		'Content-Type': 'application/json',
		headers: {"Authorization": `Token ${token}`}
	};

	try {
		if (query.type === 'coordinates') {
		const { lon, lat } = query.data;

		parameters = `lat=${lat}&lon=${lon}&units=${unit}&APPID=${apiKey}`;
		} else {
		parameters = `q=${query.data}&units=${unit}&APPID=${apiKey}`;
		}

		const res = await axios.get(url + parameters + headersToken);
		//const res = await axios.get(`http://cors-anywhere.herokuapp.com/${url}, ${parameters}, ${headersToken}`);

		return { 
		type: 'success', 
		data: res.data 
		};
	} catch (err) {
		return handleError(err);
	}
};

const handleError = err => {
  if (err.response) {
    if (err.response.status === 401) {
      	return API_KEY_ERROR;
    } else if (err.response.status === 404) {
      	return SEARCH_ERROR;
    } else if (err.response.status > 500) {
      	return SERVER_ERROR;
    }
  } else {
    	return NETWORK_ERROR;
  }
};

export function getWeather(lang){
	return async(dispatch) =>{
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const res = axios.get(process.env.REACT_APP_SERVER + '/api/weather?project_uuid=' + localStorage.getItem('persistProjectUUID') + '&language=' + lang, headersToken);

		return res.then(response => { 
			console.log('GET WEATHER Succesfully', response.data);
			return dispatch({ 
				type: GET_WEATHER, 
				payload: response.data 
			});
		}).catch((err)=> {
			console.log('Could Not Load Data from WEATHER', err.response);
			return handleError(err);
		})
	}
}